import { lazy } from "react"

export const FonctionnalitiesAndAddOn = lazy(() => import("@/views/fonctionnalitiesAndAddOn/FonctionnalitiesAndAddOn"))
export const OptionModal = lazy(()=> import('@/views/fonctionnalitiesAndAddOn/components/OptionModal'))
export const OptionsDataTable = lazy(()=> import('@/components/optionsDataTable/OptionsDataTable'))